import { useMutation } from "react-query";
import { setProfilingGroup, setTaskGroup, setWorkflowTaskAssignment } from "../lib/data";

export const useAssignTask = (taskType) => {
    return useMutation(({ sourcePage, group, taskContextKeys, assignedUser, taskTypes, taskKeys }) => {
        if (taskType === "scheduling") {
            return setProfilingGroup(sourcePage, group, taskKeys, assignedUser);
        }

        if (taskType === "duplicatestaging") {
            return setWorkflowTaskAssignment(sourcePage, group, taskKeys, assignedUser, "DuplicateStagingTask");
        }

        return setTaskGroup(sourcePage, group, taskContextKeys, assignedUser, taskTypes, taskKeys);
    });
};
